<template>
  <div class="secondtitle">
    <div class="title">{{secTitle.title}}</div>
	<dv-decoration-10 style="width:100%;height:5px;" />
  </div>
</template>

<script>

export default {
  data () {
    return {
      options: {},
    };
  },
  components: {

  },
  props: {
    secTitle: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
}
</script>
<style lang="scss">
.secondtitle{
  font-size:16px;
  color: #3EFFF4;
  .title{
	  padding: 17px 0px 10px;
	  text-align: center;
	  line-height: 22px;
  }
}
</style>